import { TableHeaderCheckbox } from 'primeng/table';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'miq-tableHeaderCheckbox',
  template: `
    <label class="container" (click)="onNativeClick($event)">
      <input #cb type="checkbox" [checked]="checked" [disabled]="disabled" (focus)="onFocus()" (blur)="onBlur()" />
      <span class="checkmark"></span>
    </label>
  `,
  standalone: false,
})
export class MiqTableHeaderCheckboxComponent extends TableHeaderCheckbox implements OnInit {
  ngOnInit() {
    this.checked = this.updateCheckedState();
  }

  onNativeClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.disabled() && this.dt.value && this.dt.value.length > 0) {
      const changeEvent: CheckboxChangeEvent = { originalEvent: event, checked: !this.checked };
      this.dt.toggleRowsWithCheckbox(changeEvent, !this.checked);
    }
  }

  /** @override required by PrimeNG 19 */
  onClick(_event: CheckboxChangeEvent) {
    // handled via onNativeClick — no-op to satisfy override contract
  }

  onFocus() {
    // intentional to override parent behavior
  }

  onBlur() {
    // intentional to override parent behavior
  }
}
